import { setLocale } from 'yup';
import { validationMessages } from '@/validation/messages';

export const configureValidation = () => {
    setLocale({
        mixed: {
            required: validationMessages.mixed.required,
            default: validationMessages.mixed.default,
        },
        string: {
            min: validationMessages.string.min,
            max: validationMessages.string.max,
            matches: validationMessages.string.matches,
        }
    });
};